"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDataContext = void 0;
const react_1 = require("react");
exports.FormDataContext = (0, react_1.createContext)({
    rootSchema: {},
    onChange: () => {
        throw new Error('onChange form data context has not been provided.');
    },
});
//# sourceMappingURL=FormDataContext.js.map